<template>
  <div>
    <ValidationObserver ref="formAdd">
      <form @submit.prevent="">
        <div class="breadcrumb-area pos-relative w-100">
          <!-- title -->
          <div class="row">
            <h5 class="col-sm-6 col-12">Chi tiết File import</h5>
            <div class="col-sm-6 col-12 d-flex justify-content-end align-items-center">
              <b-button class="ml-2" @click="dowloadError()" variant="outline-danger">
                Tải file lỗi
              </b-button>
              <b-button class="ml-2" @click="detailKpi()" variant="outline-primary">
                Chi tiết KPI
              </b-button>
              <b-button class="ml-2" @click="$router.push({ name: 'kpi record upload history' })">
                Quay lại
              </b-button>
            </div>
          </div>
          <!-- content -->
          <div class="">
            <div class="row w-100">
              <div class="col-sm-6 mt-2">
                <div class="row mb-4">
                  <div class="col-3">Loại dịch vụ:</div>
                  <div class="col-9">{{ data.type | transformData(Config.serviceType) }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Tên file tải lên:</div>
                  <div class="col-9">{{ data.name }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Trạng thái:</div>
                  <div class="col-9">
                    {{ data.status | transformData(Config.statusFileImport) }}
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Ghi chú:</div>
                  <div class="col-9">{{ data.note }}</div>
                </div>
                <div class="row mb-4">
                  <div class="col-3">Tổng số bản ghi:</div>
                  <div class="col-9">{{ data.totalRecord }}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div v-if="sseData" class="my-2 d-flex justify-content-between align-items-end">
              <div class="shell">
                <div class="bar" :style="{ width: sseData + '%' }">
                  <span class="span" v-if="sseData >= 5">{{ sseData }}%</span>
                </div>
              </div>
            </div>
            <b-tabs
              lazy
              fill
              Justified
              v-if="list.correctList.length > 0 || list.errorList.length > 0"
            >
              <b-tab title="Danh sách bản ghi thành công">
                <b-table
                  v-if="list.correctList.length > 0"
                  :fields="fieldsTable"
                  :items="list.correctList"
                  responsive
                  hover
                  sticky-header
                  :fixed="true"
                  :bordered="true"
                  style="max-height: calc(100vh - 500px)"
                  :per-page="10"
                  :current-page="currentPage"
                  show-empty
                  empty-text="Không có dữ liệu!"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(message)="data">
                    {{ data.item.message === 'Success' ? 'Đã tải lên' : data.item.message }}
                  </template>
                </b-table>
                <div v-if="list.correctList.length > 0" class="d-flex justify-content-end">
                  <b-pagination
                    class="mt-1"
                    v-model="currentPage"
                    :total-rows="list.correctList.length"
                    :per-page="10"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
                <div class="card mt-3 text-center" v-if="list.correctList.length === 0">
                  Không có bản ghi thành công!
                </div>
              </b-tab>
              <b-tab title="Danh sách bản ghi thất bại">
                <b-table
                  v-if="list.errorList.length > 0"
                  :fields="fieldsTable"
                  :items="list.errorList"
                  responsive
                  hover
                  sticky-header
                  :fixed="true"
                  :bordered="true"
                  style="max-height: calc(100vh - 500px)"
                  :per-page="10"
                  :current-page="currentPage"
                  show-empty
                  empty-text="Không có dữ liệu!"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                </b-table>
                <div v-if="list.errorList.length > 0" class="d-flex justify-content-end">
                  <b-pagination
                    class="mt-1"
                    v-model="currentPage"
                    :total-rows="list.errorList.length"
                    :per-page="10"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
                <div class="card mt-3 text-center" v-if="list.errorList.length === 0">
                  Không có bản ghi thất bại!
                </div>
              </b-tab>
            </b-tabs>
            <br />
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { FileService } from '@/services/file.service'
  import Config from '@/thirdParty/config'
  export default {
    data() {
      return {
        Config,
        data: {},
        showLoading: false,
        currentPage: 1,
        list: { correctList: [], errorList: [] },
        fieldsTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'content', label: 'Thông tin upload', thStyle: '' },
          { key: 'message', label: 'Thông báo', thStyle: '' },
        ],
        sseClient: null,
        sseData: null,
        error: '',
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },
    mounted() {
      this.fetch()
    },
    watch: {
      sseData(newSseData) {
        if (newSseData !== 'SUCCESS') {
          window.addEventListener('beforeunload', this.showCustomAlert)
        } else {
          window.removeEventListener('beforeunload', this.showCustomAlert)
        }
      },
    },
    methods: {
      async getListResult() {
        this.showLoading = true
        try {
          const response = await FileService.getListResult(this.$route.params.id)
          if (response.success) this.list = response.data
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetch() {
        this.showLoading = true
        try {
          const response = await FileService.fetchOne(this.$route.params.id)
          if (response.success && ['NEW', 'PROCESSING'].includes(response.data.status)) {
            this.readFile(this.$route.params.id, this.dataUser.token)
          } else if (response.success && response.data.status === 'SUCCESS') this.getListResult()
          else if (response.success && response.data.status === 'FALSE')
            this.confirmReadFile(this.$route.params.id)
          this.data = response.data ?? {}
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async readFile(id, bearerToken) {
        console.log(bearerToken)
        try {
          const sseClient = await fetch(
            `https://cnps.vn00.vn.fastgo.cloud:9817/file/read?id=${id}`,
            {
              headers: {
                Authorization: bearerToken,
                Accept: 'text/event-stream',
              },
            }
          )
          if (!sseClient.ok) {
            throw Error(sseClient.statusText())
          }

          for (const reader = sseClient.body.getReader(); ; ) {
            const { value, done } = await reader.read()
            if (done) {
              break
            }
            const chunk = new TextDecoder().decode(value)
            const payload = chunk.replace(/^data:/, '')
            if (payload.includes('SUCCESS')) {
              this.sseData = 'SUCCESS'
            } else this.sseData = Number(payload)
          }
          this.fetch()
        } catch (error) {
          console.log(error)
        }
      },
      async confirmReadFile(id) {
        this.approveMx('Quá trình tải của bạn đang bị tạm dừng. Bạn có muốn tiếp tục không?').then(
          s => {
            if (s === true) {
              this.readFile(id)
              this.data.status = 'PROCESSING'
            }
          }
        )
      },
      detailKpi() {
        this.$router.push({
          path: `/kpi-record/upload/detail/${this.data.fileServiceId}`,
        })
      },
      async dowloadError() {
        try {
          this.showLoading = true
          await FileService.downloadErrorFile({ id: this.$route.params.id })
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      showCustomAlert(event) {
        const customMessage = 'Bạn có thay đổi chưa được lưu. Bạn có chắc chắn muốn rời khỏi trang?'
        event.returnValue = customMessage
        alert(customMessage)
      },
    },
  }
</script>
<style scoped>
  .shell {
    height: 27px;
    width: 500px;
    border: 1px solid #aaa;
    border-radius: 13px;
    padding: 3px;
  }

  .bar {
    background: linear-gradient(to right, #b993d6, #8ca6db);
    height: 20px;
    width: 15px;
    border-radius: 9px;
  }
  .span {
    float: right;
    padding: 4px 5px;
    color: #fff;
    font-size: 0.9em;
  }
</style>
